import { render, staticRenderFns } from "./List.vue?vue&type=template&id=a8f0b41a&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=a8f0b41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f0b41a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8f0b41a')) {
      api.createRecord('a8f0b41a', component.options)
    } else {
      api.reload('a8f0b41a', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=a8f0b41a&scoped=true&", function () {
      api.rerender('a8f0b41a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/history/List.vue"
export default component.exports